module.exports = __webpack_public_path__ + "img/welder.06c70ab7.png";